var comp = 'contextualDivider';
export var dataHooks = {
  label: "".concat(comp, "-label")
};
export var sizeOptions = {
  small: 'small',
  large: 'large'
};